/**
 * Connectors Service — Report Templates API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RunReportRequest { 
    format?: RunReportRequest.FormatEnum;
    parameters?: { [key: string]: string; };
}
export namespace RunReportRequest {
    export const FormatEnum = {
        Csv: 'CSV',
        Xlsx: 'XLSX',
        Pdf: 'PDF'
    } as const;
    export type FormatEnum = typeof FormatEnum[keyof typeof FormatEnum];
}


